// src/utils/formDataUtils.js

export const districts = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", 
    "Karaikal", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
    "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", 
    "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", 
    "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", 
    "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar", "Other"
  ];
  
  export const states = ["Tamil Nadu", "Other"];
  
  export const stars = [
    "Ashwini", "Bharani", "Krithikai", "Rohini", "Mirgasheersham", "Thiruvaathirai", 
    "Punarpoosam", "Poosam", "Aayilyam", "Makam", "Pooram", "Uthiram", "Hastham", 
    "Chithirai", "Swaathi", "Visaakam", "Anusham", "Kettai", "Moolam", "Pooraadam", 
    "Uthiraadam", "Thiruvonam", "Avittam", "Chathayam/Sadayam", "Poorattathi", 
    "Uthirattathi", "Revathi"
  ];
  
  export const raasis = [
    "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
    "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
  ];
  
  export const maritalStatusOptions = ["Single", "Married"];
  
  export const idProofTypes = [
    { value: "aadhaar", label: "Aadhaar" },
    { value: "license", label: "License" }
  ];
  
  export const panCardOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
  ];

  export const roleOptions = [
    { value: "superuser", label: "Super User" },
    { value: "admin", label: "Admin" },
    { value: "user", label: "User" },
  ];